import { FieldConfig } from "../../components/FormBuilder";

export const customerFields: FieldConfig[] = [
  // { sectionTitle: "Login Details" },
  // {
  //   name: "username",
  //   label: "Username",
  //   type: "text",
  //   placeholder: "Enter username",
  //   required: true
  // },

  // {
  //   name: "email",
  //   label: "Email",
  //   type: "email",
  //   placeholder: "Enter email",
  //   required: true
  // },

  // {
  //   name: "password",
  //   label: "Password",
  //   type: "text",
  //   placeholder: "Enter password",
  //   required: true,
  //   minLength: 6,
  //   maxLength: 20,
  //   onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
  //     e.target.value = e.target.value.slice(0, 20);
  //   },
  // },
  // {
  //   name: "password_confirmation",
  //   label: "Confirm Password",
  //   type: "text",
  //   placeholder:"Confirm password",
  //    required: true ,
  //   minLength: 6,
  //   maxLength: 20,
  //   onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
  //     e.target.value = e.target.value.slice(0, 20);
  //   },
  // },

  { sectionTitle: "Code" },
  {
    name: "customer_code_option",
    label: "Customer Code Option",
    type: "chips",
    options: ["Generate", "Enter"],
    required: true,
    defaultValue: "Generate",
  },
  {
    name: "customer_code",
    label: "Customer Code",
    type: "text",
    placeholder: "Enter Customer Code",
    prefix: "CUS",
    conditional: {
      field: "customer_code_option",
      value: "Enter",
    },
  },
  {
    name: "customer_code_info",
    label: "",
    type: "info",
    defaultValue: "Auto-generate customer code by clicking 'Generate'",
    conditional: {
      field: "customer_code_option",
      value: "Generate",
    },
    readOnly: true,
  },
  { sectionTitle: "Personal Details" },
  {
    name: "first_name",
    label: "First Name",
    type: "text",
    placeholder: "Enter first name",
    required: true,
  },
  {
    name: "last_name",
    label: "Last Name",
    type: "text",
    placeholder: "Enter last name",
    required: true,
  },
  {
    name: "mobile_number",
    label: "Mobile Number",
    type: "tel",
    placeholder: "Enter mobile number",
    required: true,
    pattern: "^[0-9]{10}$", // 10 digits only
    maxLength: 10,
    minLength: 10,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      // Allow only digits and limit to 10
      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 10);
    },
  },
  // {
  //   name: "date_of_birth",
  //   label: "Date of Birth",
  //   type: "date",
  // },
  // {
  //   name: "gender",
  //   label: "Gender",
  //   type: "chips",
  //   options: ["Male", "Female", "Other"],
  // },
  // {
  //   name: "marital_status",
  //   label: "Marital Status",
  //   type: "chips",
  //   options: ["Single", "Married"],
  // },
  // {
  //   name: "father_name",
  //   label: "Father's Name",
  //   type: "text",
  //   placeholder: "Enter father's name",
  // },
  // {
  //   name: "mother_name",
  //   label: "Mother's Name",
  //   type: "text",
  //   placeholder: "Enter mother's name",
  // },
  // {
  //   name: "spouse_name",
  //   label: "Spouse Name",
  //   type: "text",
  //   placeholder: "Enter spouse name",
  // },

  {
    name: "aadhaar_number",
    label: "Aadhaar Number",
    type: "text",
    placeholder: "Enter Aadhaar number",
    pattern: "^[0-9]{12}$", // 12 digits only
    maxLength: 12,
    minLength: 12,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      // Allow only digits and limit to 12
      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 12);
    },
  },
  {
    name: "pan_number",
    label: "PAN Number",
    type: "text",
    placeholder: "Enter PAN number",
    pattern: "^[A-Z]{5}[0-9]{4}[A-Z]{1}$", // PAN format
    maxLength: 10,
    minLength: 10,
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      // Uppercase letters and digits only, limit to 10
      e.target.value = e.target.value
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, "")
        .slice(0, 10);
    },
  },
  // {
  //   name: "driving_license",
  //   label: "Driving License",
  //   type: "text",
  //   placeholder: "Enter DL number",
  // },
  // {
  //   name: "voter_id",
  //   label: "Voter ID",
  //   type: "text",
  //   placeholder: "Enter Voter ID",
  // },
  // {
  //   name: "passport_number",
  //   label: "Passport Number",
  //   type: "text",
  //   placeholder: "Enter Passport number",
  // },
  // { sectionTitle: "Others" },
  // {
  //   name: "salary",
  //   label: "Salary",
  //   type: "number",
  //   placeholder: "Enter salary"
  // },
  // {
  //   name: "employment_type",
  //   label: "Employment Type",
  //   type: "chips",
  //   options: [
  //     "Salaried",
  //     "Self-Employed",
  //     "Business",
  //     "Retired",
  //     "Student",
  //     "Other",
  //   ],
  // },

  // {
  //   name: "employer_name",
  //   label: "Employer Name",
  //   type: "text",
  //   placeholder: "Enter employer name"
  // },
  // {
  //   name: "work_experience",
  //   label: "Work Experience (Years)",
  //   type: "number",
  //   placeholder: "Enter years",
  // },
  // {
  //   name: "credit_score",
  //   label: "Credit Score",
  //   type: "number",
  //   placeholder: "Enter credit score",
  // },
  // {
  //   name: "monthly_income",
  //   label: "Monthly Income",
  //   type: "number",
  //   placeholder: "Enter monthly income",
  // },
  // {
  //   name: "other_liabilities",
  //   label: "Other Liabilities",
  //   type: "number",
  //   placeholder: "Enter amount",
  // },
  {
    name: "status",
    label: "Status",
    type: "chips",
    options: ["Active", "Inactive"],
  },
  // file upload fields (image preview)
  {
    name: "profile_photo",
    label: "Profile Photo",
    type: "file",
    accept: "image/*",
    previewUrlField: "profile_photo_url",
  },
  {
    name: "sign_photo",
    label: "Sign Photo",
    type: "file",
    accept: "image/*",
    previewUrlField: "sign_photo_url",
  },
];
